<template>
  <div id="app">
    <!-- <myHeader v-if="isMyHeader"></myHeader> -->
    <router-view v-if="isRouterAlive" />
    <!-- <myFooter v-if="isMyHeader"></myFooter> -->
  </div>
</template>
<script>
import myHeader from "@/components/myHeader.vue";
import myFooter from "@/components/myFooter.vue";
export default {
  watch: {
    $route(newVal, oldVal) {
      // console.log(newVal.meta.exp,oldVal);
      if (
        newVal.meta.exp === "登录" ||
        newVal.meta.exp === "注册" ||
        newVal.meta.exp === "忘记密码"
      ) {
        this.isMyHeader = false;
      } else {
        this.isMyHeader = true;
      }
    },
  },
  data() {
    return {
      isMyHeader: false,
    };
  },
  components: {
    myHeader,
    myFooter,
  },
  computed: {
    isRouterAlive() {
      return this.$store.state.isRouterAlive; // 用来解决路由相同不刷新问题
    },
    webConfig() {
      return this.$store.state.webConfig;
    },
  },
  created() {
    // this.adaptation();
    if (this.webConfig) {
      this.initHTML();
    } else {
      this.needProps();
    }
  },
  methods: {
    /* 监测Props */
    needProps() {
      let watchAch = this.$watch("webConfig", (val, oldVal) => {
        if (val) {
          this.initHTML();
          watchAch(); //取消监听
        }
      });
    },
    // 网页配置加载：logo、描述等
    initHTML() {
      let res = this.webConfig;
      document.title = res.title;
      // document.querySelector('link[rel="icon"]').href= res.faviconFull || '';
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", res.keywords);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", res.description);
    },
    // 是否是移动端设备
    isDevices() {
      var devices = ["iPhone", "Android", "Windows Phone"];
      var ua = window.navigator.userAgent;
      let isTrue = false; //true 移动端
      for (var i = 0; i < devices.length; i++) {
        if (ua.indexOf(devices[i]) !== -1) {
          isTrue = true;
        }
      }
      return isTrue;
    },
    // PC端适配
    adaptation() {
      let pathArr = [
        {
          target: "supermarket/shop_home/goods_list",
          path: "supermarket/shop_home/home",
        },
        {
          target: "supermarket/shop_home/introduction", //店铺详情
          path: "supermarket/shop_home/home",
        },
      ];
      let isTrue = this.isDevices();
      if (!isTrue) return; //非移动端设备
      var _hash = window.location.hash; //hash
      var wenhao = _hash.indexOf("?") - 0; //问号位置
      var queryString = wenhao > -1 ? _hash.substr(wenhao) : ""; //请求参数
      let cur = pathArr.filter((item, idx, arr) => {
        // 匹配该路径是否需要进行转换
        return _hash.indexOf(item.target) > -1;
      });
      console.log(process.env.VUE_APP_EVN);
      if (process.env.VUE_APP_EVN === "production") {
        let _url = `http://m.sctcc.cn/`;
        if (cur.length) {
          _url += `#/${cur[0].path}${queryString}`;
        } else {
          _url = `${_url}${location.hash}`;
        }
        console.log(_url);
        window.location.href = _url;
      } else if (process.env.VUE_APP_EVN === "test") {
        let _url = `http://120.78.79.8:8080/qiantai/h5-project/HZ-STAR-SPACE-MORE-TOPS/dist/`;

        if (cur.length) {
          console.log(queryString);
          _url += `#/${cur[0].path}${queryString}`;
        } else {
          _url = `${_url}${location.hash}`;
        }
        console.log(_url);
        window.location.href = _url;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #2c3e50;
  // margin-left: calc(100vw - 100%);
  min-width: 1200px;
  background: #f5f5f5;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
